import { Injectable } from '@angular/core';

import { ProxyService } from '@core/services/proxy.service';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { UserMealInfo } from '@features/ordering/models/start-favorites-meal.model';

@Injectable()
export class StartOrderService {

  constructor(private proxyService: ProxyService) { }

  getOrders(count: number = 0, status: number = 1) {
    return this.proxyService.httpGet(ApiRoutes.GET_RECENT_ORDERS + '/' + count + '?status=' + status);
  }
  getPendingOrders(count: number = 0) {
    return this.proxyService.httpGet(ApiRoutes.GET_PENDING_ORDERS + '/' + count);

  }
  getOrderImages() {
    return this.proxyService.httpGet(ApiRoutes.GET_START_ORDER_IMAGES);
  }

  getFavorites() {
    return this.proxyService.httpGet(ApiRoutes.GET_FAVORITES);
  }

  getOrderById(id: string) {
    return this.proxyService.httpGet(ApiRoutes.GET_ORDERS_ID + id);
  }

  getFavoritesById(id: string) {
    return this.proxyService.httpGet(ApiRoutes.GET_FAVORITES_ID + id);
  }
}
